// جایی که اپ از آن‌جا نصب می‌شود — و اینکه کدام «آن‌جا».
//
// ═══ چرا یک فایلِ جدا و نه دو رشته توی رابط ═══
//
// این نشانی‌ها روی هر دو صفحه‌ی بی‌حساب می‌نشینند (لینکِ عمومی و صفحه‌ی بعد
// از جواب) و روزی که اپ واقعاً منتشر شود باید **یک جا** عوض شوند.
//
// ⚠️ هیچ‌کدام هنوز واقعاً منتشر نشده — تا روزِ انتشار هر دو ۴۰۴ می‌دهند.
// ولی نشانیِ اپل دیگر حدسی نیست: `6806569361` شناسه‌ای‌ست که App Store
// Connect موقعِ ساختنِ رکوردِ اپ داد. شکلِ کوتاهِ `/app/id<n>` عمدی‌ست —
// خودش به کشور و اسمِ درست ریدایرکت می‌کند، پس نه به locale وابسته است نه
// به اسمِ فروشگاهی که هنوز ممکن است عوض شود.
//
// نشانیِ اندروید از روی `package` در apps/mobile/app.json ساخته می‌شود، که
// `app.goout.mvp` است و عمداً با شناسه‌ی iOS یکی نیست: عوض‌کردنش یعنی یک اپِ
// تازه در Firebase و یک `google-services.json` تازه، وگرنه پوش می‌میرد — و
// نصبِ فعلی هم دیگر روی خودش بروزرسانی نمی‌شود، چون اندروید بسته‌ی با نامِ
// متفاوت را اپِ دیگری می‌بیند. دو فروشگاه لازم نیست یک شناسه داشته باشند.
import { SITE } from './shareLink.ts';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.goout.mvp';
export const APP_STORE_URL = 'https://apps.apple.com/app/id6806569361';

/**
 * صفحه‌ی «اپ رو بگیر» روی خودِ سایت.
 *
 * ═══ چرا یک صفحه‌ی واسط، و نه مستقیم به فروشگاه ═══
 *
 * چون این همان چیزی‌ست که داخلِ QR می‌رود، و QR را نمی‌شود شخصی‌سازی کرد:
 * یک تصویرِ ثابت است که هر کسی با هر گوشی‌ای اسکنش می‌کند. اگر مستقیم به
 * گوگل‌پلی می‌رفت، هر آیفونی که اسکنش می‌کرد به یک صفحه‌ی بی‌فایده می‌رسید.
 *
 * پس QR به این صفحه اشاره می‌کند و **تصمیم آن‌جا گرفته می‌شود** — روی خودِ
 * دستگاهی که اسکن کرده و می‌داند چه سیستمی دارد.
 */
export const GET_APP_URL = `${SITE}/get`;

/**
 * کدام فروشگاه، بر اساسِ `navigator.userAgent`.
 *
 * `null` یعنی نه اندروید نه iOS — یعنی دسکتاپ، و آن‌جا هیچ‌کدام از دو
 * نشانی به‌درد نمی‌خورد: کسی روی لپ‌تاپ نمی‌تواند اپِ گوشی نصب کند. رابط در
 * آن حالت به‌جای دکمه یک QR نشان می‌دهد تا کاربر با گوشیِ خودش بیاید.
 *
 * تشخیصِ iPad عمداً `Macintosh` + لمس را هم می‌گیرد: آیپدهای تازه خودشان را
 * مکینتاش معرفی می‌کنند و بدونِ این شرط یک آیپد QR می‌دید به‌جای دکمه. چون
 * `navigator` این‌جا نیست، لمس به‌شکلِ ورودی می‌آید نه از DOM.
 */
export function storeUrlFor(userAgent: string, touchPoints = 0): string | null {
  const ua = userAgent || '';
  if (/android/i.test(ua)) return PLAY_STORE_URL;
  if (/iphone|ipad|ipod/i.test(ua)) return APP_STORE_URL;
  if (/macintosh/i.test(ua) && touchPoints > 1) return APP_STORE_URL;
  return null;
}
